/** Regelversion 11: Systemgesetze der Wirtschaftsordnung entwerfen (Aufruf aus actions.ts). */
import { S } from './state';
import { since } from './version';
import { TPL } from '../content/issues';
import { ISS } from '../content/states';
import { tplAvail } from './novelle9';
import { inForce } from './v2';
import { coopGov, canDraft } from './coalition';
import { woOn } from './order11';
import { SYS_IDS } from '../content/order11';

/** Zustand eines Systemgesetzes für die Anzeige. */
export function sysState(iss: string): { T: any; busy: boolean; done: boolean; mine: boolean } {
  const T = TPL(iss, 0);
  return { T, busy: !!S.issues?.[iss]?.law, done: inForce(T.t), mine: !coopGov() || canDraft('YOU', T) };
}
export function draftWo(iss: string) {
  if (!woOn() || S.phase !== 'govern' || !SYS_IDS.includes(iss) || !ISS[iss]) return;
  if (since(12) && !S.career.length) return; // Version 12: erst ab der zweiten Legislatur
  const x = sysState(iss); if (!tplAvail(x.T) || x.busy || x.done || !x.mine) return;
  if (!S.issues[iss]) S.issues[iss] = { sev: 0, prev: 0, cut: 0, law: null, on: false } as any;
  S.editing = { iss, tpl: 0, lawId: null, p: Object.fromEntries(x.T.ps.map((p: any) => [p.id, p.d])) };
}
